<div
  class="container {{ hoverClass }}"
  [ngStyle]="{
    width: width,
    height: height,
    'background-color': backgroundColor,
    border: border,
    color: color
  }"
>
  <ng-content></ng-content>
</div>
